import { BAlert, BButton, BCard } from '../../../../components/ui/generic';
import { Link, useParams } from 'react-router';
import { IconChevronLeft, IconMail, IconPhone } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { useContract } from '../../../../hooks/Contract';
import { useForm } from 'react-hook-form';
import { YousignScript } from './yousignScript';
import axiosInstance from '../../../../utils/AxiosInstance';
import { useHandleSubmitTunnel } from '../../../../hooks/useHandleSubmitTunnel';
import BLoader from '../../../../components/BLoader';
import BError from '../../../../components/BError';
import { toast } from 'react-toastify';

const Signature = () => {
  const { watch, setValue, handleSubmit } = useForm();
  const { trainingId } = useParams();
  const [contractData, setContractData] = useState({
    trainingId: trainingId,
    mode: 'phone',
  });
  const [iframe, setIframe] = useState(null);
  const signedWatch = watch('signed') ?? false;
  const contractIdWatch = watch('contractId') ?? false;
  //error will be thrown by the handleResponse function
  const { data, isSuccess, isFetching, error } = useContract(contractData);
  const onSubmit = useHandleSubmitTunnel('signature', trainingId);
  useEffect(() => {
    if (isSuccess) {
      setValue('submit', 'next');
      setValue('signed', data['signed']);
      setValue('contractId', data['contractId']);
      setIframe(data['iframe']);
    }
  }, [data, isSuccess, setValue]);
  useEffect(() => {
    if (!signedWatch && iframe) {
      let yousignIframe = new YousignScript({
        signatureLink: iframe.signers[0].signature_link,
        iframeContainerId: 'signature_link',
        isSandbox: true,
        iFrameAttributes: {
          referrerPolicy: 'origin-when-cross-origin',
        },
      });
      if (yousignIframe) {
        document.getElementById('yousign-iframe').classList.add('w-full', 'h-[528px]');
      }
    }
  }, [iframe, signedWatch]);
  useEffect(() => {
    if (signedWatch) {
      handleSubmit(onSubmit)();
    }
  }, [signedWatch]);
  console.debug(signedWatch);
  window.addEventListener('message', function (e) {
    // Check if the origin of the message is really come from Yousign
    if (e.origin === 'https://yousign.app' && e.data.type === 'yousign') {
      if (e.data.event === 'started') {
      }

      if (e.data.event === 'success') {
        axiosInstance.get(`/internal_api/tunnel/signature/get-status/${contractIdWatch}`).then((callback) => {
          if (callback.data.error) toast.error(callback.data.message);
          else {
            if (callback?.data?.signed) {
              setValue('signed', true);
            }
          }
        });
      }

      if (e.data.event === 'error') {
      }

      //Healthcheck, for debug only
      if (e.data.event === 'ping') {
      }

      if (e.data.event === 'declined') {
      }

      if (e.data.event === 'signature.done') {
      }
    }
  });

  return (
    <BCard maxSize={'md:max-w-2xl font-normal'}>
      <BCard.Header title={'Étape 4 : Signature'} withTitle />
      <BCard.Body>
        <div className={'space-y-2'}>
          <p className={'text-lg font-semibold text-slate-700'}> </p>
          <BAlert title={'Contrat d’accompagnement'}>
            Ce contrat gratuit, une fois signé, déclenche la prise de contact par notre coach en recherche d’entreprise
            pour commencer votre accompagnement.
          </BAlert>
        </div>
        {isFetching ? (
          <BLoader isComponent title={'Récupération de votre contrat'} />
        ) : error ? (
          <BError title={error?.message} description={''} />
        ) : (
          <div id={'signature_link'} className={'h-[528px] w-full'}></div>
        )}
        <div className={'flex items-center justify-between'}>
          <div>
            <Link to={`/inscription/documents/${trainingId}`} className={'hover:text-primary-700 flex items-center'}>
              <IconChevronLeft className={'size-5'} /> <p className={'text-sm'}>Retour</p>
            </Link>
          </div>
          <div className={'flex flex-col gap-2 lg:flex-row'}>
            <BButton
              onClick={() =>
                setContractData((prevState) => ({
                  ...prevState,
                  mode: 'email',
                }))
              }
              isTextNoWrap
              size={'xs'}
              isDisabled={contractData.mode === 'email'}
              label={'Code par e-mail'}
              icon={IconMail}
            />
            <BButton
              onClick={() =>
                setContractData((prevState) => ({
                  ...prevState,
                  mode: 'phone',
                }))
              }
              size={'xs'}
              isDisabled={contractData.mode === 'phone'}
              label={'Code par téléphone'}
              isTextNoWrap
              icon={IconPhone}
            />
          </div>
        </div>
      </BCard.Body>
    </BCard>
  );
};

export default Signature;
